<template>
  <div class="bg-istoreui d-flex flex-row align-items-center" style="height: calc(100vh - 70px);">
    <v-container>
      <v-row class="justify-content-center">
        <v-col :md="6">
          <div class="clearfix">
            <h1 class="float-start display-3 me-4">404</h1>
            <h4 class="pt-2">{{ langKey.titlePage404 }}</h4>
            <p class="text-medium-emphasis float-start">
              {{ langKey.labelPage404Message }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  data() {
    return {
      previousRoute: null,
    }
  },
}
</script>
